import { render, staticRenderFns } from "./AgentTable.vue?vue&type=template&id=06e319f8&scoped=true&"
import script from "./AgentTable.vue?vue&type=script&lang=js&"
export * from "./AgentTable.vue?vue&type=script&lang=js&"
import style0 from "./AgentTable.vue?vue&type=style&index=0&id=06e319f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e319f8",
  null
  
)

export default component.exports